module.exports = {
  validations: {
    general: {
      required: '必須項目です',
      greaterThan0: '1以上で指定してください。',
      greaterThanOrEqualTo0: '0以上で指定してください。',
      samePassword: 'パスワードと一致しません',
      format: '形式が正しくありません',
      inRange: '範囲内で指定してください',
      greaterThanStart: '開始時刻以降で指定してください',
      exclusive: '他と重なっています',
      minLength: '長さが不足しています',
      maxLength: '文字数が長すぎます',
      unique: '他に存在しています',
      fileType: '対応していないファイル形式です',
      myshopifyDomain: 'xxx.myshopify.com の形式で入力してください（ストアの表示名ではありません）',
    },
    receivingRequest: {
    },
    tenant: {
      autoCreatesInboundShipment: {
        defaultSender: 'デフォルト配送先がありません',
      },
    },
  },
};
